<template>
  <!-- 注册成功 -->
  <div class="box">
    <div class="content">
      <img class="reg-img" src="../../views/registration/assets/images/register_zhucechenggong.png" alt="">
      <!-- 按钮 -->
      <div class="btn-box">
        <!-- <el-button type="primary" class="btn-left" @click="handleBack">上一步</el-button> -->
        <el-button type="primary" class="btn-right" @click="handleLogin">去登录</el-button>
      </div>
      <!-- 倒计时跳转登录 -->
      <div class="jump">
        <p><span class="count">{{count}}S</span>后跳转至登录页</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "setPassword",
  props: {
    // 控制显示
    stepActive: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      // 设置显示
      activeNum: this.stepActive,
      // 倒计时
      count: 5,
      // 定时器
      timer: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.jumpLogin()
    })
  },
  beforeDestroy() {
    console.log(Boolean(this.timer));
    this.timer && clearInterval(this.timer)
  },
  methods: {
    // 返回上一页
    handleBack() {
      this.$emit('setStepActive', --this.activeNum)
    },
    // 去登录
    handleLogin() {
      this.$router.push({ path: "/login/newLogin" })
    },
    // 倒计时跳转登录页
    jumpLogin() {
      this.timer && clearInterval(this.timer)
      this.timer = window.setInterval(() => {
        if (this.count <= 0) {
          clearInterval(this.timer)
          this.timer = null
          this.handleLogin()
          this.count = 5
        } else {
          this.count -= 1
        }

      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../views/registration/assets/images/register_bg4.png")
    no-repeat;
  .content {
    box-sizing: border-box;
    padding: 0 75px;
    position: absolute;
    top: 127px;
    left: 0px;
    width: 460px;
    height: 400px;
    opacity: 1;
    border-radius: 10px;
    text-align: center;
    .reg-img {
      margin-top: 69px;
      width: 151px;
      height: 41px;
    }
    .btn-box {
      margin-top: 68px;
      box-sizing: border-box;
      .btn-left {
        width: 140px;
        height: 46px;
        font-size: 16px;
        color: #0078fc;
        background: #ffffff;
        border: 1px solid #0078fc;
        border-radius: 8px;
      }
      .btn-right {
        // width: 140px;
        width: 100%;
        font-size: 16px;
        height: 46px;
        border-radius: 8px;
        color: #fff;
        background-color: #0078fc;
        &:hover {
          background: #3393fd;
          border-color: #3393fd;
        }
        &:active {
          background: #006ce3;
          border-color: #006ce3;
        }
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
    .jump {
      margin-top: 29px;
      font-size: 14px;
      color: #999;
      .count {
        color: #0078fc;
      }
    }
  }
}
</style>